import { render, staticRenderFns } from "./programs-extra.vue?vue&type=template&id=8fe7a1f4&scoped=true"
import script from "./programs-extra.vue?vue&type=script&lang=js"
export * from "./programs-extra.vue?vue&type=script&lang=js"
import style0 from "./programs-extra.vue?vue&type=style&index=0&id=8fe7a1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0___a965578a4a18db21b1dac13b221d5bdb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe7a1f4",
  null
  
)

export default component.exports